import { React, useState, useEffect } from "react";
import { FxmsData } from "../../fxms/datas/FxData";
import { energyOptions } from "../common/commonVal";
import { getDay, get15MinOfDate, getInloInfo } from "../common/commonMethod";
import { nodeDataArray_sihwa, linkDataArray_sihwa, nodeDataArray_inchon_steam, linkDataArray_inchon_steam , nodeDataArray_inchon_air,linkDataArray_inchon_air,nodeDataArray_ansan_steam,linkDataArray_ansan_steam} from "./helper/UI_1_5.helper";
import FxRoutingDiagram  from "../components/FxRouthingDiagram";

/**
 * @description 수요공급예측 > 라우팅가이던스
 * @author SONJIEUN
 * @date 01/20/2025
 * @param {*}
 * @return  수요공급예측 > 라우팅가이던스
 */

export const UI_1_5 = () => {
  const user = FxmsData.getUser();
  const inlo = getInloInfo(FxmsData.getInlo(user.inloNo),user);  
  const date = get15MinOfDate();
  const [fetchEnergyOption, setFetchEnergyOption] = useState(energyOptions);
  const [fetchComplexInlo, setFetchComplexInlo] = useState([]);
  const [fetchTableData, setFetchTableData] = useState([]); // 테이블 데이터
  const [nodeDataArray, setNodeDataArray] = useState([]);
  const [linkDataArray, setLinkDataArray] = useState([]);
  const [selected, setSelected] = useState({
    complexInloNo: user.ugrpNo === 1021||user.ugrpNo === 1024? inlo.complexInloNo : "",
    sinkInlo : user.ugrpNo === 1024? inlo.inloNo : "",
    energy: "",
   // today : '20250515' //getDay(0) 항상 최신 데이터로 가져오게 쿼리 변경 
  });

  useEffect(() => {
    if (user.inloClCd === "PROJECT" || user.inloClCd === "COMPLEX") {
      getComplexInloData();
    }else if (user.ugrpNo == 1024) {
      selectedComplex(inlo.complexInloNo);
    }      
  }, []);

  useEffect(() => {
    console.log("selected :::: >>>", selected);
  }, [selected])

  useEffect(() => {
    selectedComplex(selected.complexInloNo);
  }, [selected.energy])

  useEffect(() => {
    setSelected((prev) => ({ ...prev, energy: "" }));
    setNodeDataArray([]);
    setLinkDataArray([]);
    setFetchTableData([]);  

  }, [selected.complexInloNo])

 
  const getComplexInloData = async () => {
    const uri = "vup/getComplexInloList"
    try {
      const res = await FxmsData.GET(uri);
      if (user.inloClCd === "PROJECT") {
        setFetchComplexInlo(res.data);
      } else {
        setFetchComplexInlo(res.data[0]);
        setSelected((prev) => {
          return { ...prev, complexInloNo: res.data[0].inloNo };
        });
      }
      console.log("complex List >> ", res.data);
    } catch (e) {
      console.log("getComplexInloList error ........", e);
    }
  }

  const selectedComplex = async (value) => {
    console.log("선택된 산단번호 ::", value);
    setSelected((prev) => ({ ...prev, complexInloNo: value }));
    
    let energylist = energyOptions;

    if (value === '11000' || value === 11000 ) {
      energylist = energyOptions.filter(x => (x.value === "AIR"));
      setFetchEnergyOption(energylist);
    } else if (value === '14000' || value === 14000 ) {
      energylist = energyOptions.filter(x => (x.value === "STEAM"));
    }    
    setFetchEnergyOption(energylist); 
      
  }

  const selectedEnergy = async (value) => {
    console.log("선택된 에너지 ::", value);
    setSelected((prev) => ({ ...prev, energy: value }));        
  }
  
  const handleSelectData = (event) => {
    const { value, name } = event.target;
    setSelected((prev) => {
      return { ...prev, [name]: value };
    })
  }

  // 조회 버튼 클릭 시 데이터 GET 함수
  const submitBtnClick = async () => {
    if (selected == null) return;

    if (selected.complexInloNo === "") {
      alert("사업장을 선택해주세요.");
      return;
    }
    if (selected.energy === "") {
      alert("에너지 종류를 선택해주세요.");
      return;
    }

    const param = {    
      sourceInlo: selected.sourceInlo,
      complexInloNo : selected.complexInloNo,
      energy : selected.energy,
      //today : selected.today.replace(/-/gi, ""),
    }

    try {
      const uri = "vup/select_1_5";
      const res = await FxmsData.GET(uri, param);
      console.log("UI_1_5 res........", res.data)

      setFetchTableData(res.data);

      makeNodeLinkInfo(res.data); // 다이어그램(go.js) 노드 정보 표시

    }catch (e) {
      console.log("UI_1_5 fetchData error", e);
    } 
  };

  const deepClone = (obj) => structuredClone ? structuredClone(obj) : JSON.parse(JSON.stringify(obj));

  const makeNodeLinkInfo = (tableData) => {
   
    let nodeDataArray = [];
    let linkDataArray = [];
    let tmpNodeDataArray= [];
    let tmpLinkDataArray = [];

    if (selected.complexInloNo === '11000' || selected.complexInloNo === 11000) {
      nodeDataArray = nodeDataArray_sihwa;
      linkDataArray = linkDataArray_sihwa;
    }else if ((selected.complexInloNo === '13000' && selected.energy==="STEAM") || (selected.complexInloNo === 13000 && selected.energy === "STEAM")) {
      nodeDataArray = nodeDataArray_inchon_steam;
      linkDataArray = linkDataArray_inchon_steam;
    }else if ((selected.complexInloNo === '13000' && selected.energy==="AIR") || (selected.complexInloNo === 13000 && selected.energy === "AIR")) {
      nodeDataArray = nodeDataArray_inchon_air;
      linkDataArray = linkDataArray_inchon_air;
    }else if ((selected.complexInloNo === '14000' && selected.energy==="STEAM") || (selected.complexInloNo === 14000 && selected.energy === "STEAM")) {
      nodeDataArray = nodeDataArray_ansan_steam;
      linkDataArray = linkDataArray_ansan_steam;
    }

    let sourceList = [];
    tmpNodeDataArray = deepClone(nodeDataArray);
    tmpLinkDataArray = deepClone(linkDataArray);

  // 소스 정보 주입 
  tmpNodeDataArray.forEach(node => {
    
    const item = tableData.find(o => o.sinkInloNo === node.inloNo); 
    if (item) node.sourceInlono = item.sourceInloNo;
  });

    /*사업장은 경로와 노드 빨간색으로 표시*/
    if (user.ugrpNo === 1024) {
      const sourceInlo = tableData.find(n => n.sinkInloNo === selected.sinkInlo).sourceInloNo;
      let key = [];

      //노드 red 추가
      tmpNodeDataArray.forEach((value) => {
        if (value.inloNo === selected.sinkInlo ) {
          value.color = "#2cc01eff"; // 객체에 color 속성 추가
          key.push(value.key);
        }else if ( value.inloNo === sourceInlo)
        {
          value.color = "#1e90ff"; // 객체에 color 속성 추가
          key.push(value.key);
        }
      });

      //경로 red 추가
      if (key.length === 2) {
        let strtKey = key[0] < key[1] ? key[0] : key[1];
        let endKey = key[0] > key[1] ? key[0] : key[1];
        let current = strtKey;

        while (current !== endKey) {
          const link = tmpLinkDataArray.find(item => item.from === current);
          if (!link) break; // 중간에 끊기면 종료
          link.color = 'red'; // 색상 변경
          current = link.to;  // 다음 노드로 이동
        }
      }


      const sinkInfo = tableData.find(n => n.sinkInloNo === selected.sinkInlo); 
      const sinkNode = nodeDataArray.find(n => n.inloNo === selected.sinkInlo); 
      const sinkLoc = sinkNode.loc.split(' ');  
          
      const x = Number(sinkLoc[0]);
      const y = Number(sinkLoc[1]);  
      tmpNodeDataArray.push( { category: "sinkSourceInfo", inloName: sinkInfo.sinkInloName , group: "sink", flowRate: `${sinkInfo.flowRate ?? 0}   Nm3/h`, pressureLoss: `${sinkInfo.pressureLoss ?? 0} bar_g`, loc: x + " " + (y-50) })
    
      //싱크주입
      const sourceInfo = tableData.find(  n => n.inloType === "SOURCE" && n.sourceInloNo === sinkInfo.sourceInloNo);
      const sourceNode = nodeDataArray.find(n => n.inloNo === sourceInfo.sourceInloNo);
      const souceLoc = sourceNode.loc.split(' ');
      const x1 = Number(souceLoc[0]);
      const y1 = Number(souceLoc[1]); 

      tmpNodeDataArray.push( { category: "sinkSourceInfo", inloName: sourceInfo.sourceInloName , group: "source", flowRate: `${sourceInfo.flowRate ?? 0}   Nm3/h`, pressureLoss: `${sourceInfo.pressureLoss ?? 0} bar_g`, loc: x1 + " " + (y1+50) })
      
       //자기가 싱크인 경우 자기 정보도 주입 

        const sourceInfo2 = tableData.find(  n => n.inloType === "SOURCE" && n.sourceInloNo === sinkInfo.sinkInloNo);
        const sourceNode2 = nodeDataArray.find(n => n.inloNo === sourceInfo2.sourceInloNo);
        const souceLoc2 = sourceNode2.loc.split(' ');
        const x2 = Number(souceLoc2[0]);
        const y2 = Number(souceLoc2[1]); 
         tmpNodeDataArray.push( { category: "sinkSourceInfo", inloName: sourceInfo2.sourceInloName , group: "source", flowRate: `${sourceInfo2.flowRate ?? 0}   Nm3/h`, pressureLoss: `${sourceInfo2.pressureLoss ?? 0} bar_g`, loc: x2 + " " + (y2+50) })

    }else{

      tableData.map((item) => {
        const sinkNode = nodeDataArray.find(n => n.inloNo === item.sinkInloNo); 
        const sinkLoc = sinkNode.loc.split(' ');
        /*sink 정보는 모두 넣어주고 Source 정보는 최신 정보 한개만 넣어준다.*/
        /*group이 source면 정보위치가 x=x, y= y+50 , sink면 정보위치가 x=x, y= y-50*/     
        
        const x = Number(sinkLoc[0]);
        const y = Number(sinkLoc[1]);  
          if(item.inloType === "SINK")
          {
            tmpNodeDataArray.push( { category: "sinkSourceInfo", inloName: item.sinkInloName , group: "sink", flowRate: `${item.flowRate ?? 0}   Nm3/h`, pressureLoss: `${item.pressureLoss ?? 0 } bar_g`, loc: x + " " + (y-50) })
          }else{
          //Source 정보 주입 
            const sourceNode = nodeDataArray.find(n => n.inloNo === item.sourceInloNo);
            const souceLoc = sourceNode.loc.split(' ');
            const x = Number(souceLoc[0]);
            const y = Number(souceLoc[1]); 
            tmpNodeDataArray.push( { category: "sinkSourceInfo", inloName: item.sourceInloName , group: "source", flowRate: `${item.flowRate ?? 0}   Nm3/h`, pressureLoss: `${item.pressureLoss ?? 0} bar_g`, loc: x + " " + (y+50) })
            sourceList.push(item.sourceInloNo); 
          }
        })

    }
  
  setNodeDataArray(tmpNodeDataArray);
  setLinkDataArray(tmpLinkDataArray);

  }

  const makeTable = () => {
    
    const tableHtml = [];
    tableHtml.push(
        <tbody> {/*TABLE 부터 단지 별 리스트 받아서 테이블 만들기 */}
          <tr>
            <th>Sink</th>
            {
            fetchTableData.map((item) => (
              <td>{item.sinkInloName}</td>
            ))
            }
          </tr>
          <tr>
            <th>Source</th>
            {
              fetchTableData.map((item) => (
                <td>{item.sourceInloName}</td>
              ))
            }
          </tr>
          <tr>
            <th>수요량(Nm3/h)</th>
            {
              fetchTableData.map((item) => (
                <td>{item.flowRate}</td>
              ))
            }
          </tr>
          <tr>
            <th>압력손실(bar)</th>
            {
              fetchTableData.map((item) => (
                <td>{item.pressureLoss}</td>
              ))
            }
          </tr>
        </tbody>

    );

      return (<div className="FxMuiTable">
      <table>
        <colgroup>
          <col />        
        </colgroup>
        <thead>
        </thead>
        {tableHtml}
      </table>
    </div>)
    
  }

  return (
    <>
      <div className="predict">
        <div className="FxCrudFilter">
          <div className="FxFilterLeft">    
           {user.ugrpNo === 1021 || user.ugrpNo === 1024 ?
          <select className="FxSelectSearch" value={inlo.complexInloNo}>
           <option value={inlo.complexInloNo}> {inlo.complexInloName} </option>
           </select>
            :
            <select className="FxSelectSearch" onChange={(e) => selectedComplex(e.target.value)}>
                <option value="">산업단지 전체</option>
                {fetchComplexInlo.map((item) => (
                  <option key={item.inloNo} value={item.inloNo} name="complexInloNo">
                    {item.inloName}
                  </option>
                ))}
            </select>
            }             
           
            <label className="FxLabelSearch"></label>
            <select className="FxSelectSearch" name="energy" value={selected.energy} onChange={(e) =>selectedEnergy(e.target.value)}>
              <option value="">에너지 종류</option>
              {fetchEnergyOption.map((item, index) => (
                <option key={index} value={item.value} name="energy">{item.label}</option>
              ))}
            </select>
            {user.ugrpNo === 1024? 
              <select className="FxSelectSearch" value={inlo.inloNo}>
              <option value={inlo.inloNo}> {inlo.inloName} </option>
              </select>
            : null
          //   <select className="FxSelectSearch" name="sinkInlo" value={selected.sinkInlo} onChange={handleSelectData}>
          //   <option value="">SINK 사업장</option>
          //   {fetchSinklist.map((item, index) => (
          //     <option key={index} value={item.inloNo} name="sinkInlo">{item.inloName}</option>
          //   ))
          //   }            
          // </select>
          }
          </div>
          <div className="FxFilterRight">
            <input className="FxButtonSearch" type="button" value="조회" onClick={submitBtnClick} />
          </div>
        </div>
        <div className="FxCrudDataGrid">
          <div className="vupReportTitle">
            <strong>라우팅 가이던스</strong>
            <div class="legend">
              <span></span>
              수요예측값
            </div>
          </div>
               {nodeDataArray.length === 0? <FxRoutingDiagram/>:<FxRoutingDiagram tableInput="true" nodeData={nodeDataArray} linkData={linkDataArray} selectedSink={selected.sinkInlo} selectedSource={selected.sourceInlo} ugrpNo={user.ugrpNo}/> }
               
               {user.ugrpNo !== 1024?     
                <div className="vupSimulatorWrap">
                 <strong>수요/공급 예측 기반 라우팅 가이던스</strong>                   
                 {fetchTableData.length === 0 ?<div class="FxMuiTable">
                     <table>
                       <colgroup>
                       </colgroup>
                       <thead>
                       </thead>
                       <tbody>
                         <tr>
                           <th>
                            {selected.complexInloNo === "" ||
                            selected.energy === ""
                              ? "필터를 선택해주세요"
                              : "데이터가 없습니다."}
                          </th>
                         </tr>
                       </tbody>
                     </table>
                   </div> : makeTable()
                   }
                   </div>:null}
      
        </div>
      </div>
    </>
  )
}